import { createAction } from "@reduxjs/toolkit";
import { Officer, PaginationOptions } from "../../interfaces";
import * as OfficerActionTypes from "./types";

export const loadAllOfficer = createAction<Partial<PaginationOptions>>(
  OfficerActionTypes.fetch_paginated_officers_saga
);
export const loadOfficerById = createAction<string>(
  OfficerActionTypes.fetch_officer_by_id_saga
);
export const createOfficer = createAction<Omit<Officer, "uid">>(
  OfficerActionTypes.create_new_officer_saga
);
export const updateOfficer = createAction<Officer>(
  OfficerActionTypes.update_officer_saga
);
export const deleteOfficerById = createAction<string>(
  OfficerActionTypes.delete_officer_saga
);
export const resetPasswordById = createAction<string>(
  OfficerActionTypes.reset_password_officer_saga
);
